import { render, staticRenderFns } from "./ProjectStatistic.vue?vue&type=template&id=52e7484c&"
import script from "./ProjectStatistic.vue?vue&type=script&lang=js&"
export * from "./ProjectStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports